import React, { FC, useContext, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ReviewPageContext } from '.';
import InterviewHead from 'components/Interview/Head';

// Imports validés par ton fichier exemple
import Button from 'components/Button';
import DownloadIcon from 'components/icons/Download';
import SettingsIcon from 'components/icons/Settings';
import { HeadButtons } from 'components/PageHead'; 

const Head: FC = () => {
  const { interview } = useContext(ReviewPageContext);
  const { id } = useParams();

  const menteeName: string = useMemo(() => {
    if (
      interview?.mentorship?.mentee?.firstName &&
      interview.mentorship.mentee.lastName
    ) {
      return `${interview.mentorship.mentee.firstName} ${interview.mentorship.mentee.lastName}`;
    }
    return 'Entretien';
  }, [interview]);

  return (
    <InterviewHead
      backTo={`/admin/mentoring/mentees/${id}/interviews/`}
      title={menteeName}
      interview={interview}
      variant="admin"
    >
      {/* On place les boutons ici (entre les balises). 
          C'est ce qu'on appelle les "children".
      */}
      <HeadButtons>
        <Link to="export">
          <Button variant="outlined" icon={<DownloadIcon />}>
            Exporter la liste
          </Button>
        </Link>
       
        <Button
          variant="outlined"
          icon={<SettingsIcon />}
          onClick={() => window.dispatchEvent(new CustomEvent('open-mentorship-settings'))}
        >
          Colonnes
        </Button>
      </HeadButtons>
    </InterviewHead>
  );
};

export default Head;